import '../../monitoring/filters/tag/tags_filter_view.js.coffee'
Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.TagsFilterView extends Monitoring.Views.SocialContents.Filters.TagsFilterView

  initialize: ({searchQuery, facet, tagsByClientCode}) ->
    super(searchQuery: searchQuery, facet: facet, tagsByClientCode: tagsByClientCode)

  _filterName: ->
    I18n.t('surveys.dashboard.filters.tags')
